import * as React from "react";
import { LanguageContext } from "../../context/app-context";
import { Footer } from "./footer";
import { Header } from "./header";
import { Seo } from "./seo";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../services/theme";
import { ScrollTopButton } from "../shared/scroll-top-button";

interface LayoutProps {
    children: React.ReactNode;
    title: string;
    description: string;
    showTemperatureSlider?: boolean;
    fadedHeader?: boolean;
    switchTitleOrder?: boolean;
    path: string;
    faqs?: { question: string; answer: string }[];
    month?: string;
    noHeaderFooter?: boolean;
    rootClasses?: string;
    og?: string;
}

export const Layout = ({
    children,
    title,
    description,
    switchTitleOrder,
    path,
    faqs,
    noHeaderFooter,
    rootClasses,
    og
}: LayoutProps) => {
    //contexts
    //const [lang] = React.useContext(LanguageContext);
    //const dispatch = useAppDispatch();

    //const isLoading = useAppSelector((state) => state.global.isLoading);
    // TODO
    const isLoading = false;

    //console.log(faqs);
    return (
        <div
            className={`root relative h-full border-zinc-800 text-zinc-800 ${rootClasses}`}
        >
            <ThemeProvider theme={theme}>
                <Seo
                    title={title}
                    description={description}
                    path={path}
                    switchTitleOrder={switchTitleOrder}
                    faqs={faqs}
                    og={og}
                ></Seo>

                {isLoading && <div className="lds-dual-ring"></div>}

                {!noHeaderFooter && (
                    <>
                        <Header></Header>
                        <div className="overflow-x-hidden pt-[62px] md:pt-[65px]">
                            {children}
                        </div>
                        <Footer></Footer>
                    </>
                )}
                {noHeaderFooter && <>{children}</>}

                <ScrollTopButton />
            </ThemeProvider>
        </div>
    );
};
